<div class="playlist-header">
  <div class="header-cover">
    <div class="playlist-covers" *ngIf="playlistCovers$ | async as covers">
      <img alt="preview-playlist" *ngFor="let cover of covers" [src]="cover" />
    </div>
    <div class="playlist-infos">
      <div class="playlist-title">{{ playlist.name }}</div>
      <div class="playlist-details">
        <span *ngIf="playlist.type === 'manual'; else auto" translate>
          MEDIA.PLAYLIST.PLAYLIST_MANUAL
        </span>
        <ng-template #auto>
          <span translate>MEDIA.PLAYLIST.PLAYLIST_AUTO</span>
        </ng-template>
      </div>
      <div class="playlist-actions">
        <rk-button
          *ngIf="playlist.type === 'manual'"
          [label]="'MEDIA.PLAYLIST.ADD_TRACKS' | translate"
          [faIcon]="'fa-plus'"
          [matMenuTriggerFor]="uploadMenu"
        ></rk-button>
        <rk-button
          *ngIf="playlist.type !== 'manual'"
          [label]="'MEDIA.PLAYLIST.EDIT_PLAYLIST' | translate"
          [faIcon]="'fa-pen'"
          (click)="editPlaylist()"
        ></rk-button>
        <rk-button
          data-cy="playlist-header-more"
          [btnStyle]="'orange'"
          [matMenuTriggerFor]="tableMenu"
          [svgIcon]="'dot-down'"
          (click)="placeMatMenu()"
        ></rk-button>
      </div>
    </div>
  </div>
</div>
<div class="playlist-length-search flex justify-between items-end">
  <div *ngIf="playlist" class="playlist-length" [class.hidden]="!playlist.nbTracks">
    <ng-container *ngIf="!processing && !(isLoadingTracks$ | async)">
      <ng-container *ngIf="playlist.nbTracks; else noTracks">
        <ng-container
          *ngIf="
            playlist.nbTracks === displayedTracks && !currentSearchValue;
            else filtering
          "
        >
          <span>
            {{ 'MEDIA.PLAYLIST.NB_TRACKS' | translate: { tracks: playlist.nbTracks } }}
          </span>
          -
          <span translate [translateParams]="getMinutesAndHours(tracksTime$ | async)"
            >MEDIA.BACS.TIME</span
          >
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
  <div class="search" [class.hidden]="processing || !playlist.nbTracks">
    <rk-search-bar #searchBar (inputted)="onSearchInput($event)"></rk-search-bar>
  </div>
</div>
<ng-template #noTracks> <span translate>MEDIA.PLAYLIST.NO_TRACKS</span> </ng-template>
<ng-template #filtering>
  <span
    class="filtering"
    [innerHTML]="
      'MEDIA.PLAYLIST.FILTERING'
        | translate: { displayed: displayedTracks, total: playlist.nbTracks }
    "
  ></span>
</ng-template>
<mat-menu #tableMenu="matMenu" [overlapTrigger]="false">
  <ng-container>
    <button *ngIf="playlist.type === 'manual'" mat-menu-item (click)="editPlaylist()">
      <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.EDIT</span>
    </button>
    <button data-cy="playlist-more-duplicate" mat-menu-item (click)="duplicatePlaylist()">
      <mat-icon fontSet="fa" fontIcon="fa-clone"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DUPLICATE</span>
    </button>
    <div class="menu-separator"></div>
    <button data-cy="playlist-more-delete" mat-menu-item (click)="deletePlaylist()">
      <mat-icon fontSet="fa" fontIcon="fa-trash"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.DELETE</span>
    </button>
  </ng-container>
</mat-menu>

<mat-menu #uploadMenu="matMenu" [overlapTrigger]="false">
  <ng-container>
    <button mat-menu-item (click)="addTracks()">
      <mat-icon fontSet="fa" fontIcon="fa-inbox"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.FROM_LIBRARY</span>
    </button>
    <button mat-menu-item (click)="uploadTracks()">
      <mat-icon fontSet="fa" fontIcon="fa-laptop"></mat-icon>
      <span translate>MEDIA.CONTEXT_MENU.FROM_COMPUTER</span>
    </button>
  </ng-container>
</mat-menu>
